export default "__VITE_ASSET__505e2a7b__"